module.exports = __webpack_public_path__ + "static/media/postman.c94be4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/postman.png
// module id = 120
// module chunks = 0